const SocialIconTelegram = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.996799 8.15353C4.88911 6.45771 7.48459 5.33972 8.78324 4.79957C12.4912 3.25732 13.2616 2.98941 13.7638 2.98056C13.8743 2.97862 14.1212 3.00599 14.2812 3.1358C14.4163 3.2454 14.4534 3.39346 14.4712 3.49738C14.489 3.60129 14.5112 3.83802 14.4936 4.02299C14.2926 6.13422 13.4232 11.2576 12.9809 13.6222C12.7937 14.6228 12.4252 14.9583 12.0684 14.9911C11.293 15.0624 10.7043 14.4787 9.95329 13.9864C8.77816 13.2161 8.11429 12.7366 6.97362 11.9849C5.65539 11.1162 6.50994 10.6387 7.2612 9.85845C7.45781 9.65424 10.8741 6.54689 10.9402 6.26501C10.9485 6.22975 10.9561 6.09834 10.8781 6.02895C10.8 5.95956 10.6848 5.98329 10.6016 6.00216C10.4838 6.02891 8.60648 7.26973 4.96978 9.7246C4.43692 10.0905 3.95427 10.2688 3.52183 10.2594C3.04511 10.2491 2.12808 9.98989 1.44636 9.76829C0.610203 9.49649 -0.0543554 9.35279 0.00351276 8.89119C0.0336541 8.65076 0.36475 8.40487 0.996799 8.15353Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { SocialIconTelegram };
